import { render, staticRenderFns } from "./AccountedMoney.vue?vue&type=template&id=6b71bd04&scoped=true&"
import script from "./AccountedMoney.vue?vue&type=script&lang=js&"
export * from "./AccountedMoney.vue?vue&type=script&lang=js&"
import style0 from "./AccountedMoney.vue?vue&type=style&index=0&id=6b71bd04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b71bd04",
  null
  
)

export default component.exports